import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface LoaderProps {
  size?: number;
  color?: "inherit" | "primary" | "secondary";
  className?: string;
}

/**
 * Small inline spinner for use inside buttons/rows while an action is in flight
 * (e.g. confirm-delete, checkout). For full-page loading, prefer the existing
 * `.loading-overlay`/`circular-progress-bar` pattern already used in edit.tsx.
 */
const Loader: React.FC<LoaderProps> = ({ size = 18, color = "inherit", className }) => (
  <CircularProgress size={size} color={color} className={className} />
);

export default Loader;
